import { render, staticRenderFns } from "./allocate-status-select.vue?vue&type=template&id=c3070c14&"
import script from "./allocate-status-select.vue?vue&type=script&lang=js&"
export * from "./allocate-status-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports